import { render, staticRenderFns } from "./SalesApplicationIBAN.vue?vue&type=template&id=36a11242&"
import script from "./SalesApplicationIBAN.vue?vue&type=script&lang=ts&"
export * from "./SalesApplicationIBAN.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports